import Vue from 'vue';
import App from './App.vue';
import './filters';
import router from './router';
import store from './store';
import VueResource from 'vue-resource';
import 'flexboxgrid2/flexboxgrid2.min.css';
import VueMq from 'vue-mq';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faFacebookF, faTwitter, faInstagram, faFlickr } from '@fortawesome/free-brands-svg-icons';
import { faSave, faTrashAlt } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import lightboxcss from 'lightbox2/dist/css/lightbox.css';
import lightbox from 'lightbox2/dist/js/lightbox';
import VueCookies from 'vue-cookies';
import Chart from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import VTooltip from 'v-tooltip';
import { get, set, clear } from 'idb-keyval';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import simplebar from 'simplebar-vue';
import 'simplebar/dist/simplebar.min.css';
import Vuelidate from 'vuelidate';

library.add(faFacebookF, faTwitter, faInstagram, faFlickr, faSave, faTrashAlt);

VueCookies.config('1d');
Vue.component('simplebar', simplebar);

Vue.use(VueResource);
Vue.use(VueMq, {
	breakpoints: {
		sm: 768,
		lg: Infinity
	}
});
Vue.use(VueCookies);
Vue.use(VTooltip);
Vue.use(Vuelidate);

Vue.component('fa-icon', FontAwesomeIcon);
Vue.component('v-select', vSelect);

Object.defineProperty(Vue.prototype, '$idbGet', { value: get });
Object.defineProperty(Vue.prototype, '$idbSet', { value: set });
Object.defineProperty(Vue.prototype, '$idbClear', { value: clear });

Vue.http.interceptors.push((request) => {
	// Adding auth token to all request headers
	// TODO move to httpOnly cookie
	request.headers.set('Authorization', 'Bearer ' + VueCookies.get('token'));
});

Chart.defaults.global.defaultFontFamily = 'IndexText-Regular';
Chart.defaults.global.defaultFontColor = '#000000';

Vue.config.productionTip = false;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */
const components = require.context('./components', true, /\.vue$/i);
components.keys().forEach((fileName) => {
	Vue.component(fileName.split('/').pop().split('.')[0], components(fileName).default || components(fileName));
});

new Vue({
	router,
	store,
	render: function(h) {
		return h(App);
	}
}).$mount('#app');
